import React from 'react'
import ReactSelect from 'react-select'

export default ({ ...props }) => (
  <ReactSelect {...props} />
)



// WEBPACK FOOTER //
// ./client/src/components/Select.js